import { useEffectWithController } from '@carvana/merch-react-hooks';
import { useContext } from 'react';
import { useUserId, useUserLocation } from '~/context/common/UserContext';
import DiscountContext from '~/context/vdp/DiscountContext';
import fetchDiscounts from '~/services/vdp/fetchDiscounts';
import { generateErrorLogger } from '~/utilities/loggers';

export default function useGetDiscounts() {
  const {
    discounts: { setData, setError, setLoading }
  } = useContext(DiscountContext);
  const userId = useUserId();
  const { state } = useUserLocation();

  useEffectWithController(
    controller => {
      setLoading();

      fetchDiscounts(state, userId, controller)
        .then(res => setData(res.data.content?.discounts ?? []))
        .catch(
          generateErrorLogger(
            'Get discounts',
            {},
            { callback: setError, controller }
          )
        );
    },
    [setData, setError, setLoading, state, userId]
  );
}
